import { Pipe, PipeTransform } from '@angular/core';
import values from 'lodash-es/values';

type List<T> = ArrayLike<T>;

@Pipe({
    name: 'values',
    standalone: true
})
export class ValuesPipe implements PipeTransform {
    transform<T>(collection: List<T> | null | undefined): T[] {
        return values(collection);
    }
}
